@if (pdRecords.length === 0) {
  <p class="text-muted text-center py-3">No recent awards found.</p>
} @else {
  <div class="row align-items-center mb-2">
    <div class="col-6">
      <h5 class="mb-0">Recent PD Awards</h5>
    </div>
    <div class="col-6">
      <span
        class="float-end"
        [certTooltip]="'No PD records selected'"
        [enableTooltip]="selectedPDRecordIds().length === 0"
      >
        <a
          role="button"
          class="btn btn-outline-primary float-end dropdown-toggle"
          aria-expanded="false"
          data-bs-toggle="dropdown"
          [class.disabled]="selectedPDRecordIds().length === 0"
        >
          Actions
          <ul class="dropdown-menu dropdown-menu-end">
            <li>
              <a class="dropdown-item clickable" (click)="onUpdate()">Update PD records</a>
            </li>
            <li>
              <a class="dropdown-item clickable" (click)="onDelete()">Delete PD records</a>
            </li>
          </ul>
        </a>
      </span>
      <button class="btn btn-outline-primary float-end me-2" (click)="resetFilters()">Reset Filters</button>
    </div>
  </div>
  <div formLevelValidationErrors [errorEmitter]="errorEmitter" class="mb-2"></div>
  <ag-grid-angular class="grid ag-theme-alpine" [gridOptions]="gridOptions" [rowData]="pdRecords" />
}
